import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { PollyManageDataService } from '../polly-manage-data-service/polly-manage-data.service';
import { LicenseBasedAppList, UserResponse, UserRole, VIEW_ONLY } from 'polly-commons';
import { map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { PollyManageBackendService } from '../polly-manage-backend-service/polly-manage-backend.service';

@Injectable({
  providedIn: 'root',
})
export class PollyManageViewOnlyRoleGuardService  {
  constructor(
    private readonly router: Router,
    private readonly manageDataService: PollyManageDataService,
    private readonly pollyManageBackendService: PollyManageBackendService
    ) {}

  public canActivate(): Observable<boolean> {
    const userRole: UserRole | null = this.manageDataService.getCurrentUserRole();
    let isOmixAtlasAvailable: boolean = this.manageDataService.isAppAvailable(LicenseBasedAppList.OMIXATLAS);
    if (userRole) {
      if (isOmixAtlasAvailable && ![VIEW_ONLY].includes(userRole.attributes.role_name)) {
        return of(true);
      } else {
        this.router.navigate(['manage/workspaces/dashboard'], { replaceUrl: true});
        return of(false);
      }
    }
    return this.pollyManageBackendService.getCurrentUserInfo().pipe(
      map((userInfo: UserResponse) => {
        this.manageDataService.userInfo = userInfo;
        this.manageDataService.currentUserInfo = userInfo.data;
        if (userInfo.included && userInfo.included.length) {
          const orgInfo = userInfo.included.find(item => item.type === 'organizations');
          if (orgInfo) {
            this.manageDataService.currentUserOrganization = {
              org_id: Number(orgInfo.id),
              org_name: orgInfo.attributes.name
            };
          }
          const licenseInfo = userInfo.included.find(item => item.type === 'licenses');
          if (licenseInfo) {
            this.manageDataService.currentUserLicenseInfo = licenseInfo;
          }
          const roleInfo = userInfo.included.find(item => item.type === 'roles');
          if (roleInfo) {
            const currentUserRole: UserRole = roleInfo;
            this.manageDataService.currentUserRole = currentUserRole;
            isOmixAtlasAvailable = this.manageDataService.isAppAvailable(LicenseBasedAppList.OMIXATLAS);
            if (isOmixAtlasAvailable && ![VIEW_ONLY].includes(currentUserRole.attributes.role_name)) {
              return true;
            } else {
              this.router.navigate(['manage/workspaces/dashboard'], { replaceUrl: true});
              return false;
            }
          }
        }
        return false;
      })
    );
  }
}
